/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Article50_TitleInputs */

const en_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU AI Act Article 50 transparency`)
};

const de_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparenz nach Artikel 50 des EU-KI-Gesetzes`)
};

const fr_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparence au titre de l’article 50 du règlement européen sur l’IA`)
};

const es_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparencia del artículo 50 de la Ley de IA de la UE`)
};

const it_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasparenza ai sensi dell’articolo 50 dell’AI Act dell’UE`)
};

const nl_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparantie volgens artikel 50 van de EU-AI-verordening`)
};

const pl_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejrzystość na podstawie art. 50 unijnego aktu w sprawie AI`)
};

const fi_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU:n tekoälysäädöksen 50 artiklan läpinäkyvyys`)
};

const da_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemsigtighed efter artikel 50 i EU’s AI-forordning`)
};

const sv_about_article50_title = /** @type {(inputs: About_Article50_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transparens enligt artikel 50 i EU:s AI-förordning`)
};

/**
* | output |
* | --- |
* | "EU AI Act Article 50 transparency" |
*
* @param {About_Article50_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_article50_title = /** @type {((inputs?: About_Article50_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Article50_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_article50_title(inputs)
	if (locale === "fr") return fr_about_article50_title(inputs)
	if (locale === "es") return es_about_article50_title(inputs)
	if (locale === "it") return it_about_article50_title(inputs)
	if (locale === "nl") return nl_about_article50_title(inputs)
	if (locale === "pl") return pl_about_article50_title(inputs)
	if (locale === "fi") return fi_about_article50_title(inputs)
	if (locale === "da") return da_about_article50_title(inputs)
	if (locale === "sv") return sv_about_article50_title(inputs)
	return en_about_article50_title(inputs)
});